import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { normalizeLocale } from "../l10n/util.js";
import { waitFor } from "./async.js";
export var withEpaasApi = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(f) {
    var _global,
      epaasApiIsReady,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _global = _args.length > 1 && _args[1] !== undefined ? _args[1] : window;
          epaasApiIsReady = function epaasApiIsReady() {
            return _global.epaas && _global.epaas.api.isInitialized();
          };
          _context.next = 4;
          return waitFor(epaasApiIsReady, 500);
        case 4:
          return _context.abrupt("return", f(_global.epaas.api));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function withEpaasApi(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var setLocaleFromConsentController = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(locale) {
    var _global,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _global = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : window;
          _context2.next = 3;
          return withEpaasApi(function (api) {
            return api.setLocale(normalizeLocale(locale));
          }, _global);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function setLocaleFromConsentController(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var showPolicyPage = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(container) {
    var _global,
      policypage,
      _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _global = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : window;
          _context4.next = 3;
          return withEpaasApi(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(api) {
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", api.policypage);
                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function (_x4) {
              return _ref4.apply(this, arguments);
            };
          }(), _global);
        case 3:
          policypage = _context4.sent;
          policypage.showPolicyPage(container);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function showPolicyPage(_x3) {
    return _ref3.apply(this, arguments);
  };
}();